import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import styles from './Trainer.module.css'; // Import the CSS Module
import { db } from '../../../firebase-config';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

function Trainer() {
    const [trainers, setTrainers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchTrainers();
    }, []);

    const fetchTrainers = async () => {
        try {
            setLoading(true);
            console.log('Fetching trainers from Firebase...');
            
            const q = query(collection(db, 'trainers'), orderBy('order', 'asc'));
            const querySnapshot = await getDocs(q);
            const firebaseTrainers = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            
            console.log('Firebase trainers:', firebaseTrainers);
            setTrainers(firebaseTrainers);
            
            console.log(`Total trainers: ${firebaseTrainers.length} from CMS`);
            
        } catch (error) {
            console.error('Error fetching trainers:', error);
            // Set empty array if Firebase fails
            setTrainers([]);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className={styles.container}>
                <p className={styles.paragraph}>
                    Let's meet with the team of our industry expert trainers. We believe that you will be able to change your life with the most advanced AI integrated training module cooked by Affiliate Ritual.
                </p>
                <div className={styles.loadingContainer}>
                    Loading trainers...
                </div>
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <p className={styles.paragraph}>
                Let's meet with the team of our industry expert trainers. We believe that you will be able to change your life with the most advanced AI integrated training module cooked by Affiliate Ritual.
            </p>
            <div className={styles.sliderContainer}>
                {trainers.length > 0 ? (
                    <Swiper
                        effect={'coverflow'}  // Coverflow 3D effect
                        grabCursor={true}  // Enables cursor grabbing effect
                        centeredSlides={true}  // Keeps the active slide centered
                        slidesPerView={'auto'}  // Dynamically adjusts slides based on screen width
                        coverflowEffect={{
                            rotate: 20,
                            stretch: 0,
                            depth: 100,
                            modifier: 1,
                            slideShadows: true,
                        }}
                        loop={true}  // ✅ Enables infinite swiping
                        
                        pagination={{ clickable: true }}  // Adds dots navigation
                        autoplay={{  // ✅ Auto slides
                            delay: 3000,  // Slides every 3 seconds
                            disableOnInteraction: false, // Prevents pausing when user interacts
                        }}
                        initialSlide={Math.floor(trainers.length / 2)}
                        speed={600}  // ✅ Makes transitions smooth
                        modules={[EffectCoverflow, Pagination]}
                        className={styles.sliderContainer}
                    >
                        {trainers.map((item, i) => (
                            <SwiperSlide key={item.id || i} className={styles.item}>
                                <img
                                    className={styles.img}
                                    src={item.imgLink}
                                    alt={item.alt}
                                />
                                <div className={styles.txtPos}>
                                    <div className={styles.name}>{item.name}</div>
                                    <div className={styles.position}>{item.position}</div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div className={styles.noTrainersContainer}>
                        No trainers available
                    </div>
                )}
            </div>
        </div>
    );
}

export default Trainer;